import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Empenho do Projeto",
  path: "/prestacaocontas/pcoprojeto/:pcoProjetoId/empenho",
  parent: "pcoprojeto",
  name: "pcoprojeto_empenho",
  component: () => import("@/views/prestacaocontas/pcoempenho/CadastroComGrid.vue"),
  meta: {
   permissions: [eTipoPermissao.CONVENIOPROJETOSNOVO_MENU_1500100199],
  },
  goesToMenu: false,
 },
]
